import { useState, useEffect, useRef } from 'react'
import { FileText, Menu, Printer } from 'lucide-react'
import leiloesService from '../../services/leiloesService'
import { useOrganizador } from '../../contexts/OrganizadorContext'
import { useSidebar } from '../../components/layout/Layout'
import CatalogoLeilaoButton from '../../components/catalogos/CatalogoLeilaoButton'

export default function NotaCompromissoList() {
  const [leiloes, setLeiloes] = useState([])
  const [selectedLeilao, setSelectedLeilao] = useState('')
  const [notasPorFolha, setNotasPorFolha] = useState(2)
  const { organizadorAtivo } = useOrganizador()
  const { setSidebarOpen } = useSidebar()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (organizadorAtivo?.id) {
      loadLeiloes()
    }
  }, [organizadorAtivo])

  const loadLeiloes = async () => {
    try {
      setLoading(true)
      const response = await leiloesService.getByOrganizador(organizadorAtivo.id, { per_page: 100 })
      const leiloesData = response || []
      setLeiloes(leiloesData)
      if (leiloesData.length > 0) {
        setSelectedLeilao((leiloesData.find(l => l.status === 'on') || leiloesData[0]).id.toString())
      }
    } catch (error) {
      console.error('Erro ao carregar leilões:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="">
      <div className="w-full px-3 sm:px-6 py-4 sm:py-6 space-y-4 sm:space-y-6">
        {/* Header */}
        <div className="no-print bg-gradient-to-r from-amber-600 to-amber-700 rounded-xl px-4 sm:px-6 py-4 sm:py-6">
          <div className="flex items-center justify-between mb-4 md:hidden">
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-xl text-white hover:bg-white/20 transition-all duration-200"
            >
              <Menu className="h-6 w-6" />
            </button>
            <h1 className="text-lg font-semibold text-white truncate">Nota de Compromisso</h1>
            <div className="w-10"></div>
          </div>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-3xl font-bold text-white hidden md:block">Nota de Compromisso</h1>
              <p className="text-amber-100 mt-1 text-sm sm:text-base hidden sm:block">
                Notas de compromisso em branco para preenchimento durante o leilão
              </p>
            </div>
            <div className="flex items-center gap-3">
              <select
                value={selectedLeilao}
                onChange={(e) => setSelectedLeilao(e.target.value)}
                className="bg-white border border-gray-200 text-amber-600 px-3 py-2 rounded-xl text-sm font-medium min-w-[200px] focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              >
                <option value="">Selecione um leilão...</option>
                {leiloes.map(leilao => (
                  <option key={leilao.id} value={leilao.id}>
                    {leilao.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Configuração + Botão Gerar */}
        {selectedLeilao && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex flex-wrap items-center gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notas por folha</label>
                <select
                  value={notasPorFolha}
                  onChange={(e) => setNotasPorFolha(Number(e.target.value))}
                  className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                  <option value={2}>2 notas por folha</option>
                  <option value={3}>3 notas por folha</option>
                </select>
              </div>

              <div className="ml-auto">
                <CatalogoLeilaoButton
                  leilaoId={selectedLeilao}
                  organizadorId={organizadorAtivo.id}
                  leilaoNome={leiloes.find(l => String(l.id) === String(selectedLeilao))?.nome || ''}
                  label="Gerar PDF"
                  endpoint={`nota-compromisso?notas_por_folha=${notasPorFolha}`}
                />
              </div>
            </div>
          </div>
        )}

        {/* Info */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <div className="flex items-start gap-3">
            <FileText className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm text-amber-800">
              <p className="font-medium mb-1">Sobre a Nota de Compromisso</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Gera notas para todos os lotes do leilão selecionado</li>
                <li>Campos do comprador ficam em branco para preenchimento manual</li>
                <li>Cada nota contém: vendedor, fazenda, dados do lote, observações e espaço para parcelas</li>
                <li>Ideal para uso durante o leilão presencial</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
